'use strict';

require('../../../modules/es.array.includes');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');
module.exports = getBuiltInPrototypeMethod('Array', 'includes');